import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The checking veil of a conditional dialog opened via `HlmDialogOpener.openWithCheck`: a centered
 * pane the dialog shows while its verdict resolves. Project the spinner and the message — the pane
 * owns only the layout, so the host (boxed or full-screen) keeps its own chrome. See ../CONTRACT.md.
 */
@Component({
  selector: 'hlm-dialog-checking',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center' },
  template: `<ng-content />`,
})
export class DialogCheckingComponent {}
